module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/illustration.json
// module id = 355
// module chunks = 223946623817901